import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Container, Box, Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState<{ name: string; email: string; picture: string } | null>(null);

  const handleLoginSuccess = (credentialResponse: any) => {
    console.log('Credenciais recebidas:', credentialResponse);
    const token = credentialResponse.credential;

    // Armazena o idToken no LocalStorage
    localStorage.setItem('idToken', token);

    setLoading(true);
    fetch('https://ouvi-api.cftechlab.com/auth/google-login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Resposta do servidor:', data);
        localStorage.setItem('user', JSON.stringify(data?.user));

        setLoading(false);
        if (data.message === 'Authentication successful') {
          navigate('/dashboard');
        } else {
          console.error('Login falhou:', data.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error('Erro no login:', error);
      });
  };

  const handleLoginError = () => {
    console.error('Erro ao fazer login com Google.');
  };

  return (
    <div className="login-container">
    <Container maxWidth="sm">
      <Box className="login-box">
        <Typography variant="h4" className="login-title">
          Bem-vindo ao Ouvi
        </Typography>
        <Box className="alert-box">
          <Typography variant="body1">
            🚀 Acesso Antecipado: Estamos em fase de acesso antecipado. Participe e ajude a moldar o futuro da conversão de texto para áudio!
          </Typography>
        </Box>

        {loading && (
          <Box className="flex justify-center mb-4">
            <CircularProgress color="primary" />
          </Box>
        )}

        {!loading && (
          <Box className="mt-4">
            <GoogleLogin
              onSuccess={handleLoginSuccess}
              onError={handleLoginError}
            />
          </Box>
        )}

        {user && (
          <Box className="user-info">
            <Typography variant="body1">
              Bem-vindo, {user.name}!
            </Typography>
            <img
              src={user.picture}
              alt="Profile"
              className="user-picture"
            />
          </Box>
        )}
      </Box>
    </Container>
  </div>
  );
};

export default LoginPage;
